import React from 'react';
import { useMsal } from '@azure/msal-react';
import { resetPostHog, trackEvent } from '../utils/posthog';

interface LogoutButtonProps {
    className?: string;
}

/** Key set by native auth login pages to indicate the session type */
export const NATIVE_AUTH_SESSION_KEY = 'smartblocek_native_auth';

function isNativeAuthSession(): boolean {
    return localStorage.getItem(NATIVE_AUTH_SESSION_KEY) === 'true';
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className = 'btn' }) => {
    const { instance } = useMsal();

    const handleLogout = () => {
        // Track logout event before logging out
        trackEvent('user_logged_out');

        // Reset PostHog user
        resetPostHog();

        if (isNativeAuthSession()) {
            // Native auth: clear local cache and redirect to login page
            // No server-side Microsoft session to end
            localStorage.removeItem(NATIVE_AUTH_SESSION_KEY);
            localStorage.clear();
            window.location.href = '/auth/login';
        } else {
            // Old redirect flow: use MSAL logout (ends Microsoft session)
            instance.logoutRedirect({
                postLogoutRedirectUri: window.location.origin
            }).catch((error) => {
                console.error('Logout failed:', error);
                // Fallback: clear cache and redirect
                sessionStorage.clear();
                window.location.href = '/auth/login';
            });
        }
    };

    return (
        <button
            onClick={handleLogout}
            className={className}
            style={{
                background: 'rgba(239, 68, 68, 0.1)',
                color: '#dc2626',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                borderRadius: '12px',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
                const target = e.target as HTMLButtonElement;
                target.style.background = 'rgba(239, 68, 68, 0.15)';
                target.style.transform = 'translateY(-1px)';
                target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.2)';
            }}
            onMouseLeave={(e) => {
                const target = e.target as HTMLButtonElement;
                target.style.background = 'rgba(239, 68, 68, 0.1)';
                target.style.transform = 'translateY(0px)';
                target.style.boxShadow = 'none';
            }}
        >
            🚪 Odhlásiť sa
        </button>
    );
};

export default LogoutButton;